import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@core/ngrx-legacy';

import { ReportConfigurationHttpClient } from './report-configuration-http-client';
import { ReportConfigurationActions } from './report-configuration.store';

@Injectable({ providedIn: 'root' })
export class ReportConfigurationEffects {
  private readonly reportConfigurationService = inject(ReportConfigurationHttpClient);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(ReportConfigurationActions, this.actions$);

  public fetchReportConfiguration$ = this.effects(ReportConfigurationActions.fetch, () =>
    this.reportConfigurationService.loadReportConfiguration(),
  );

  public updateReportConfiguration$$ = this.effects(
    ReportConfigurationActions.update,
    ({ payload }) => this.reportConfigurationService.updateReportConfiguration(payload),
  );
}
